import { useCallback, useRef } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'store'
import { setSubmitToken } from 'store/RecaptchaSlice'

export const useRecaptcha = () => {
  const dispatch = useDispatch()
  const submitToken = useSelector(
    (state: RootState) => state.recaptcha.submitToken,
  )
  const { executeRecaptcha } = useGoogleReCaptcha()

  const throttleHandle = useRef<NodeJS.Timeout | undefined>(undefined)

  const refreshSubmitToken = useCallback(() => {
    if (!executeRecaptcha) return

    throttleHandle.current && clearTimeout(throttleHandle.current)
    throttleHandle.current = setTimeout(async () => {
      const token = await executeRecaptcha('submit')
      dispatch(setSubmitToken(token))
    }, 1000 * 5)
  }, [executeRecaptcha, dispatch])

  const getSubmitToken = useCallback(async () => {
    if (!executeRecaptcha) return
    return await executeRecaptcha('submit')
  }, [executeRecaptcha])

  return {
    submitToken,
    refreshSubmitToken,
    getSubmitToken,
  }
}
